import { createMalformedApiResponseError } from "./api-client-error";
import { requestApiResponse } from "./request-api-response";
const validatePasswordResetCompletionResponse = (data) => {
    if (data === null ||
        typeof data !== "object" ||
        Array.isArray(data) ||
        typeof data.success !== "boolean") {
        throw createMalformedApiResponseError(data);
    }
    return data;
};
const validatePasswordResetVerificationResponse = (data) => {
    const response = validatePasswordResetCompletionResponse(data);
    if (response.success === false) {
        return response;
    }
    const token = response.payload?.token;
    if (typeof token !== "string" || token.trim().length === 0) {
        throw createMalformedApiResponseError(data);
    }
    return response;
};
export const requestPasswordReset = async (client, data) => requestApiResponse(() => client.post("/password/reset-request", data), { validateApiResponse: validatePasswordResetCompletionResponse });
export const verifyCode = async (client, data) => requestApiResponse(() => client.post("/password/verify-code", data), { validateApiResponse: validatePasswordResetVerificationResponse });
export const resetPassword = async (client, data) => requestApiResponse(() => client.post("/password/reset", data), { validateApiResponse: validatePasswordResetCompletionResponse });
